const Hidden = (/* props */) => null;

export default Hidden;



// WEBPACK FOOTER //
// ./src/components/views/Hidden.jsx